import { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaTimes,
  FaFacebookF,
  FaTiktok,
  FaYoutube,
  FaMapMarkerAlt,
  FaEnvelope,
  FaClock,
  FaPhone,
} from "react-icons/fa";
import MobileMenu from "./MobileMenu";
const OffcanvasMenu = ({ isOpen, onClose }) => {
  // Ngăn scroll khi menu mở
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isOpen]);

  return (
    <>
      {/* Overlay */}
      <div
        className={`offcanvas__overlay ${isOpen ? "overlay-open" : ""}`}
        onClick={onClose}
      />

      <div className="fix-area">
        <div className={`offcanvas__info ${isOpen ? "info-open" : ""}`}>
          <div className="offcanvas__wrapper">
            <div className="offcanvas__content">
              {/* Top */}
              <div className="offcanvas__top mb-5 d-flex justify-content-between align-items-center">
                <div className="offcanvas__logo">
                  <Link
                    to="/"
                    className="offcanvas__logo-link"
                  >
                    <img
                      src="/logo-design24.webp"
                      alt="logo-img"
                    />
                    Học viện Design24
                  </Link>
                </div>
                <div className="offcanvas__close">
                  <button
                    onClick={onClose}
                    aria-label="Đóng menu"
                  >
                    <FaTimes aria-hidden="true" />
                  </button>
                </div>
              </div>

              {/* Text */}
              <p className="text d-none d-xl-block">
                Chúng tôi luôn sẵn sàng hỗ trợ bạn. Hãy liên hệ để được tư vấn
                và hợp tác hiệu quả.
              </p>

              {/* Menu Mobile - bạn có thể render menu ở đây */}
              <MobileMenu />

              {/* Contact */}
              <div className="offcanvas__contact">
                <h4>Thông tin liên hệ</h4>
                <ul>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon">
                      <FaMapMarkerAlt />
                    </div>
                    <div className="offcanvas__contact-text">
                      Địa chỉ: 166 đường Nguyễn Văn Cừ Nối Dài, An Bình, Ninh
                      Kiều, Cần Thơ
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon">
                      <FaEnvelope />
                    </div>
                    <div className="offcanvas__contact-text">
                      <a href="mailto:design24.vn@gmail.com">
                        design24.vn@gmail.com
                      </a>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon">
                      <FaClock />
                    </div>
                    <div className="offcanvas__contact-text">
                      Thời gian làm việc: Thứ Hai - Thứ Sáu, 08:00 - 17:00
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon">
                      <FaPhone />
                    </div>
                    <div className="offcanvas__contact-text">
                      <a href="tel:0704888009">0704.888.009</a> -{" "}
                      <a href="tel:0784888009">0784.888.009</a>
                    </div>
                  </li>
                </ul>

                <div className="header-button mt-4">
                  <Link
                    to="/lien-he"
                    className="theme-btn text-center"
                  >
                    Liên hệ chúng tôi
                  </Link>
                </div>

                {/* Social */}
                <div className="social-icon d-flex align-items-center">
                  {/* Facebook */}
                  <a
                    href="https://www.facebook.com/www.design24.edu.vn"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <FaFacebookF aria-hidden="true" />
                  </a>

                  {/* Youtube */}
                  <a
                    href="https://www.youtube.com/@design2424"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                  >
                    <FaYoutube aria-hidden="true" />
                  </a>

                  {/* Tiktok */}
                  <a
                    href="https://www.tiktok.com/@design24_channel"
                    className="icon"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="TikTok"
                  >
                    <FaTiktok aria-hidden="true" />
                  </a>

                  {/* Phone */}
                  <a
                    href="tel:+84704888009"
                    aria-label="Gọi số 0704 888 009"
                  >
                    <FaPhone aria-hidden="true" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OffcanvasMenu;
